export const ITEMS_PER_SLIDE = 9;
